import { html, ifDefined, ovl, TemplateResult, unsafeHTML } from "../../.."
import { getDateValue } from "../../../global/globals"
import {
  _HookTableClickedExecutionToSetType,
  HookTableClicked,
  HookTableClicked_Type,
  HookViewHeaderCellClass,
  HookViewHeaderCellClass_Type,
  HookViewRowCellClass,
  HookViewRowCellClass_ReturnType,
  HookViewRowCellClass_Type,
  HookViewRowClass,
  HookViewRowClass_ReturnType,
  HookViewRowClass_Type,
} from "../../../global/hooks"
import { T } from "../../../textapi"
import { DialogOk } from "../../dialog/dialogapi"
import { DialogType } from "../../dialog/sysdialogbase"
import {
  _GetHeaderPart,
  _GetRowDisplayValue,
  _GetTableDialogTitle,
  GetRendererFn,
} from "../helpers"
import {
  DisplayMode,
  OvlSysColumn,
  TableClickModifiersType,
  ViewRowClassType,
} from "../table"
import { SYSTableDef, TableGet } from "../tableapi"

export const _TableDetailViewRenderer = async (
  def: SYSTableDef,
  rowKey: string,
  row: any
) => {
  let tb = TableGet(def.id)

  const handleRowClick = async (e) => {
    let currentModifiers: TableClickModifiersType = {
      altKey: e.altKey,
      ctrlKey: e.ctrlKey,
      shiftKey: e.shiftKey,
    }
    let key
    let colKey
    let targetId = e.target.id

    // get first key and colKey from current target upwards in dom-tree

    let currentNode = e.target
    let linkHandledByOvl = false
    let linkHandledBySystem = false

    for (let zz = 0; zz < 5; zz++) {
      if (!linkHandledByOvl) {
        linkHandledByOvl =
          currentNode.classList &&
          currentNode.classList.contains("ovl-hook-handled")
      }
      if (!linkHandledBySystem) {
        linkHandledBySystem =
          currentNode.classList &&
          currentNode.classList.contains("ovl-sys-handled")
      }
      if (!colKey) {
        colKey = currentNode.getAttribute("data-col")
      }
      key = currentNode.getAttribute("data-rowkey")
      if (key) {
        break
      }
      currentNode = currentNode.parentElement
      if (!currentNode) {
        break
      }
    }

    if (linkHandledByOvl) {
      // helps with links
      e.preventDefault()
    }

    // was it a feedbackrowFn?
    if (targetId.startsWith("ovlfeedbackbtn")) {
      let dialogType: DialogType
      if (e.target.classList.contains("__error")) {
        dialogType = "error"
      } else if (e.target.classList.contains("__warning")) {
        dialogType = "warning"
      } else if (e.target.classList.contains("__success")) {
        dialogType = "success"
      } else if (e.target.classList.contains("__information")) {
        dialogType = "information"
      }

      if (key) {
        let actionKey = "SYSFeeback"
        let actionName = T("SYSTableRowFnFeedbackOverview")
        let title = _GetTableDialogTitle(
          def,
          actionKey,
          actionName,
          1,
          tb.dataDef.data,
          key
        )
        let ovlSysState = tb.dataDef.data[key].OvlSysState as OvlSysColumn
        let feedback = ovlSysState.fnFeedback

        let details = Object.keys(feedback)
          .sort((a, b) => feedback[b].ts - feedback[a].ts)
          .map((k) => {
            let tb = TableGet(feedback[k].defId)
            let fnName = T(tb.def.options.customRowActions[k].translationKey)
            let ts = getDateValue(
              new Date().setTime(feedback[k].ts),
              "timestamp"
            )
            let feedbackMsg = feedback[k].text
            if (typeof feedbackMsg === "string") {
              feedbackMsg = unsafeHTML(<string>feedbackMsg)
            }
            // prettier-ignore
            return html`
              <div><i class="__${feedback[k].type} sap-icon--message-${feedback[k].type}"></i> ${ts}</div>
              <div>${fnName}</div>
              <div>${html`${feedbackMsg}`}</div>
            `
          })

        DialogOk(
          html`<div class="ovl-feedback-overview">
            <div></div>
            <div>${T("SYSTableRowFnFeedbackOverviewColAction")}</div>
            <div>${T("SYSTableRowFnFeedbackOverviewColMessage")}</div>
            ${details}
          </div>`,
          {
            type: dialogType,
            title,
            instance: "ovl-feedback-overview",
          }
        )
      }

      return
    }

    // we need to use this hook to do e.preventDefault, stopPropagation,...
    // it is important this one is first and sync
    let functionName = HookTableClicked
    let fn = ovl.getActions().app.features[def.feature]?.hooks?.[functionName]
    const executionToSet: _HookTableClickedExecutionToSetType = {
      selectionLogic:
        linkHandledByOvl || linkHandledBySystem ? "Ignore" : "Mode1",
      expandTextLogic: linkHandledBySystem ? "Ignore" : "Default",
    }
    if (fn) {
      let value: HookTableClicked_Type = {
        columnKey: colKey,
        defId: def.id,
        e,
        executionToSet,
        modifiers: currentModifiers,
        rowKey: key,
        row: tb.dataDef.data[key],
        linkType: linkHandledByOvl
          ? "OvlHook"
          : linkHandledBySystem
            ? "System"
            : "None",
        displayType: "DetailView",
        expandClicked: false,
      }

      Object.defineProperty(value, "executionToSet", {
        value: executionToSet,
        writable: false,
        configurable: false,
        enumerable: true,
      })

      await fn(value)
    }

    if (executionToSet.selectionLogic === "Ignore") {
      return
    }
  }

  const handleHeaderColumnClick = async (e) => {
    let currentModifiers: TableClickModifiersType = {
      altKey: e.altKey,
      ctrlKey: e.ctrlKey,
      shiftKey: e.shiftKey,
    }

    let currentNode: HTMLElement = e.target

    let linkHandledByOvl = false
    let linkHandledBySystem = false
    let key

    for (let zz = 0; zz < 5; zz++) {
      if (!linkHandledByOvl) {
        linkHandledByOvl =
          currentNode.classList &&
          currentNode.classList.contains("ovl-hook-handled")
      }
      if (!linkHandledBySystem) {
        linkHandledBySystem =
          currentNode.classList &&
          currentNode.classList.contains("ovl-sys-handled")
      }
      key = currentNode.getAttribute("data-headercol")
      if (key) {
        break
      }
      currentNode = currentNode.parentElement
      if (!currentNode) {
        break
      }
    }

    if (linkHandledByOvl) {
      // helps with links
      e.preventDefault()
    }
    // we need to use this hook to do e.preventDefault, stopPropagation,...
    // it is important this one is first and sync
    let functionName = HookTableClicked
    let fn = ovl.getActions().app.features[def.feature]?.hooks?.[functionName]
    const executionToSet: _HookTableClickedExecutionToSetType = {
      selectionLogic:
        linkHandledByOvl || linkHandledBySystem ? "Ignore" : "Mode1",
      expandTextLogic: linkHandledBySystem ? "Ignore" : "Default",
    }
    if (fn) {
      let value: HookTableClicked_Type = {
        columnKey: key,
        defId: def.id,
        e,
        executionToSet,
        modifiers: currentModifiers,
        linkType: linkHandledByOvl
          ? "OvlHook"
          : linkHandledBySystem
            ? "System"
            : "None",
        rowKey: undefined,
        row: undefined,
        displayType: "DetailView",
        expandClicked: false,
      }
      Object.defineProperty(value, "executionToSet", {
        value: executionToSet,
        writable: false,
        configurable: false,
        enumerable: true,
      })

      await fn(value)
    }
    if (executionToSet.selectionLogic === "Ignore") {
      return
    }
  }

  let tableTitle
  if (def.title.show && def.title.translationKey) {
    tableTitle = html` <div class="ovl-detailview-tabletitle">
      ${T(def.title.translationKey)}
    </div>`
  }

  let actionKey = "SYSDetailView"
  let actionName = T("SYSTableRowFnDetailView")
  let title = _GetTableDialogTitle(
    def,
    actionKey,
    actionName,
    1,
    tb.rows,
    rowKey
  )

  let functionName = HookViewHeaderCellClass.replace("{subFeature}", "")
  let customHeaderCellClasses
  let fn = ovl.getActions().app.features[def.feature]
  if (fn?.hooks?.[functionName]) {
    customHeaderCellClasses = fn.hooks[functionName](<
      HookViewHeaderCellClass_Type
    >{
      columns: def.columns,
      displayMode: <DisplayMode>"DetailView",
      feature: def.feature,
      tableDefId: def.id,
    })
  }
  if (!customHeaderCellClasses) {
    customHeaderCellClasses = {}
  }

  let customRowCellClasses: HookViewRowCellClass_ReturnType
  functionName = HookViewRowCellClass.replace("{subFeature}", "")
  fn = ovl.getActions().app.features[def.feature]
  if (fn?.hooks?.[functionName]) {
    customRowCellClasses = fn.hooks[functionName](<HookViewRowCellClass_Type>{
      columns: def.columns,
      row,
      rowKey,
      displayMode: <DisplayMode>"DetailView",
      feature: def.feature,
      tableDefId: def.id,
      def,
    })
  }

  let rowClass
  let rowTooltipMsg
  let draggable
  functionName = HookViewRowClass.replace("{subFeature}", "")

  if (fn?.hooks?.[functionName]) {
    let status: ViewRowClassType = await fn.hooks[functionName](<
      HookViewRowClass_Type
    >{
      rowKey,
      tableDef: def,
      tableData: tb.dataDef,
      row,
    })
    if (status) {
      rowClass = status.className
      rowTooltipMsg = status.tooltip
      if (!rowTooltipMsg) {
        rowTooltipMsg = undefined
      }
      draggable = status.draggable === true ? true : undefined
    }
  }

  let feedback = _GetFeedback(def, row, rowKey)

  let columns = def.columns
  // group by detailviewGroups
  let groupedColumns = {}
  let isFirstCol = true
  Object.keys(columns)
    .sort((a, b) => columns[a].groups.group - columns[b].groups.group)
    .forEach((k) => {
      if (!groupedColumns[columns[k].groups.group]) {
        groupedColumns[columns[k].groups.group] = {}
      }
      groupedColumns[columns[k].groups.group][k] = columns[k]
    })
  return html`
  <div class="ovl-smart-padding-lr-symmetrical">
        <div class="fd-layout-panel ">
          <div class="fd-layout-panel__title">
          ${tableTitle}

          <h3 class="ovl-detailview-title">
            ${title}
          </h3>
          </div>
          <div class="fd-layout-panel__body ovl-detailview-row ${rowClass}" title=${ifDefined(rowTooltipMsg)} draggable=${ifDefined(draggable)}>

    ${Object.keys(groupedColumns).map((g) => {
      let groupsState = def.options.rendering.groups[g]
      let detailviewGroupClassName = `detailviewgroup_${g}`
      let detailviewGroupLabelClassName = `grp__label`
      let detailviewGroupFieldsClassName = `grp__fields`
      let groupLabel
      if (groupsState) {
        if (groupsState.className) {
          detailviewGroupClassName = `ovl-detailviewgroupuser ${groupsState.className}`
        } else {
          detailviewGroupClassName = `ovl-detailviewgroup_${g}`
        }
        groupLabel = groupsState.translationKey
        if (groupLabel) {
          groupLabel = unsafeHTML(
            `<h4 class="fd-form-label ${detailviewGroupLabelClassName}">${T(groupLabel)}</h4>`
          )
        }
      }
      let columnRenderingState = def?.uiState?.columnsRenderingState?.columns

      let groupedColumnKeys = Object.keys(groupedColumns[g])
        .sort((a, b) => columns[a].order - columns[b].order)
        .filter((f) => {
          let valid = true
          let visibility = columnRenderingState?.[f]?.visibility
          if (visibility.indexOf("View") < 0) {
            valid = false
          }
          return valid
        })
      if (groupedColumnKeys.length === 0) {
        return null
      } else {
        return html`
          <div class="ovl-detailviewgroup ${detailviewGroupClassName}">
            ${groupLabel}
            <div class="${detailviewGroupFieldsClassName}">
              ${groupedColumnKeys.map((k) => {
                let column = def.columns[k]

                let customHeaderCellClass: string = ""
                let captionTooltip
                if (customHeaderCellClasses[k]) {
                  customHeaderCellClass = customHeaderCellClasses[k].className
                  captionTooltip = customHeaderCellClasses[k].tooltip
                }

                let rowFnFeedbackHint
                if (isFirstCol && feedback) {
                  rowFnFeedbackHint = feedback
                }
                isFirstCol = false

                let customRowCellClass: string = ""
                let draggable =
                  customRowCellClasses?.[k]?.draggable === true
                    ? true
                    : undefined
                let valueTooltip = customRowCellClasses?.[k]?.tooltip
                if (!valueTooltip) {
                  valueTooltip = undefined
                }
                if (customRowCellClasses?.[k]?.className) {
                  customRowCellClass = customRowCellClasses[k].className
                }

                let rowPart = _GetRowDisplayValue(
                  def,
                  k,
                  row,
                  rowKey,
                  "DetailView"
                )

                let caption = _GetHeaderPart(def, column, k, "DetailView")
                // prettier-ignore
                let valuePart = html`<div
                  @click=${async (e) => await handleRowClick(e)}
                  title=${ifDefined(valueTooltip)}
                  draggable=${ifDefined(draggable)}
                  class=${`ovl-detailview-value  col__${k} ctl__${column.control} tpe__${column.type} ${customRowCellClass}`}
                >${rowPart}${rowFnFeedbackHint}</div>`
                return html`<div
                  class="ovl-detailview-column column__${k}"
                  data-col=${k}
                  data-headercol=${k}
                  data-rowkey=${rowKey}
                >
                  <div
                    @click=${async (e) => await handleHeaderColumnClick(e)}
                    title=${ifDefined(captionTooltip)}
                    class="fd-form-label ovl-detailview-caption col__${k}  ctl__${column.control} tpe__${column.type} ${customHeaderCellClass} "
                  >
                    ${caption}
                  </div>
                  ${valuePart}
                </div>`
              })}
            </div>
          </div>
        `
      }
    })}
          </div>
        </div>

    </div></div>`
}

export const _GetFeedback = (
  def: SYSTableDef,
  row: any,
  rowKey: string
): TemplateResult => {
  let feedback
  let feedbackLevel = def.options.feedback.level
  if (feedbackLevel !== "0:none") {
    let ovlSysState = row["OvlSysState"] as OvlSysColumn
    let fnFeedback = ovlSysState.fnFeedback
    let feedBackErrorCount = 0
    let feedBackWarningCount = 0
    let feedBackInformationCount = 0
    let feedBackSuccessCount = 0
    Object.keys(fnFeedback).forEach((fnKey) => {
      switch (fnFeedback[fnKey].type) {
        case "error":
          feedBackErrorCount++
          break
        case "information":
          feedBackInformationCount++
          break
        case "success":
          feedBackSuccessCount++
          break
        case "warning":
          feedBackWarningCount++
          break
      }
    })
    let feedbackLevelInt = parseInt(feedbackLevel.split(":")[0])
    let btnid = `ovlfeedbackbtn_${def.id}_${rowKey}`
    if (
      feedbackLevelInt >= 3 &&
      feedBackInformationCount > 0 &&
      feedBackSuccessCount >= 0 &&
      feedBackErrorCount === 0 &&
      feedBackWarningCount === 0
    ) {
      // if there is only information and maybe a success we display information icon
      feedback = html`<button
        id="${btnid}"
        class="fd-button ovl-rowfnhintbutton __information"
      >
        <i class="sap-icon--message-information"></i>
      </button>`
    } else if (
      feedbackLevelInt > 3 &&
      feedBackSuccessCount > 0 &&
      feedBackErrorCount === 0 &&
      feedBackInformationCount === 0 &&
      feedBackWarningCount === 0
    ) {
      // if there is only success we display success icon
      feedback = html`<button
        id="${btnid}"
        class="fd-button ovl-rowfnhintbutton __success"
      >
        <i class="sap-icon--message-success"></i>
      </button>`
    } else if (
      feedbackLevelInt >= 2 &&
      feedBackWarningCount > 0 &&
      feedBackErrorCount === 0
    ) {
      // if we have warnings and no errors display warning icon
      feedback = html`<button
        id="${btnid}"
        class="fd-button ovl-rowfnhintbutton __warning"
      >
        <i class="sap-icon--message-warning"></i>
      </button>`
    } else if (feedbackLevelInt >= 1 && feedBackErrorCount > 0) {
      // if we have errors display error icon
      feedback = html`<button
        id="${btnid}"
        class="fd-button ovl-rowfnhintbutton __error"
      >
        <i class="sap-icon--message-error"></i>
      </button>`
    }
  }
  return feedback
}
